import { createRouter, createWebHashHistory } from 'vue-router'

import SuperTurboDesigner from './components/superturbo_designer.vue'
import Apps from './components/apps.vue'
import Account from './components/account.vue'
import Statistics from './components/statistics.vue'
import Login from './components/login.vue'
import Register from './components/register.vue'

const routes = [
  {
    path: '/',
    component: SuperTurboDesigner,
    children: [{
      path: '',
      component: Apps
    }]
  },
  {
    path: '/apps',
    component: SuperTurboDesigner,
    children: [{
      path: '',
      component: Apps
    }]
  },
  {
    path: '/account',
    component: SuperTurboDesigner,
    children: [{
      path: '',
      component: Account
    }]
  },
  {
    path: '/statistics',
    component: SuperTurboDesigner,
    children: [{
      path: '',
      component: Statistics
    }]
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/register',
    component: Register
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

function onLoginHost () {

  try {

    return window.location.origin === new URL(VUE_APP_MANAGER_URL).origin
  } catch (error) {

    return false
  }
}

router.beforeEach((to) => {

  if (onLoginHost() && (to.path === '/' || to.path === '/apps' || to.path === '/account' || to.path === '/statistics')) {

    return { path: '/login' }
  }
})

export default router
